import React, { FC } from 'react';
import translate from '@translate';
import Grid, { GridItem } from 'src/components/Grid';
import TextField from 'src/components/TextField';
import Select from 'src/components/Select';
import { GeisPackingType } from 'src/types/transportPackageType';
import { ConstantsCodeType } from 'src/types/constantsCodes';

export interface DetailPropsType {
    data: GeisPackingType;
    selectedSsrcs: string[];
    packageTypeOptions: ConstantsCodeType[];
    disableEdit: boolean;
    onChangeSsrcs: (values: string[]) => void;
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={6}>
                <TextField
                    value={props.data.CODE}
                    name="CODE"
                    label={translate('geisPackingTypeDetail.code')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={props.data.NAME}
                    name="NAME"
                    label={translate('geisPackingTypeDetail.name')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={
                        Number(props.data.RETURNABLE) === 1
                            ? translate('utils.boolCodes.yes')
                            : translate('utils.boolCodes.no')
                    }
                    name="RETURNABLE"
                    label={translate('geisPackingTypeDetail.returnable')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={
                        Number(props.data.ACTIVE) === 1
                            ? translate('utils.boolCodes.yes')
                            : translate('utils.boolCodes.no')
                    }
                    name="ACTIVE"
                    label={translate('geisPackingTypeDetail.active')}
                    fullWidth
                    disabled
                />
            </GridItem>
            <GridItem cols={12}>
                <Select
                    options={props.packageTypeOptions}
                    value={props.selectedSsrcs}
                    onChange={(value) => {
                        const next = Array.isArray(value)
                            ? value.map((item) => String(item))
                            : value
                              ? [String(value)]
                              : [];
                        props.onChangeSsrcs(next);
                    }}
                    name="PACKAGE_TYPE_SSRCS"
                    label={translate('geisPackingTypeDetail.packageTypes')}
                    fullWidth
                    multiple
                    limitTags={6}
                    disabled={props.disableEdit}
                    helperText={translate('geisPackingTypeDetail.packageTypesHint')}
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
